import {BreadcrumbItem, BreadcrumbLink, Breadcrumbs, View, ViewHeader} from "@variocube/app-ui";
import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {CreditorMutation, useCreditorApi} from "../../../api";
import {useLocalization} from "../../../i18n";
import {CreditorForm} from "./form";

export function CreditorNew() {
	const {t} = useLocalization();
	const navigate = useNavigate();
	const {createCreditor} = useCreditorApi();

	const handleSave = async (mutation: CreditorMutation) => {
		const {id} = await createCreditor(mutation);
		navigate(`../${id}`, {relative: "path"});
	};

	return (
		<View>
			<Breadcrumbs>
				<BreadcrumbItem>{t("navigation.admin")}</BreadcrumbItem>
				<BreadcrumbLink component={Link} to={`..`}>{t("creditors.plural")}</BreadcrumbLink>
				<BreadcrumbItem>{t("creditors.new.title")}</BreadcrumbItem>
			</Breadcrumbs>
			<ViewHeader title={t("creditors.new.title")} />
			<CreditorForm loading={false} onCancel={() => navigate(-1)} onSave={handleSave} />
		</View>
	);
}
